import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  AddEffectRegistrationEvaluationTimeOptionRequest,
  EffectRegistrationEvaluationTimeOptionsClient,
} from 'requests/nswag/nllMedicineTasks/NllMedicineTasksClient';

export default function useAddEvaluationTimeOption() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (request: IAddEvaluationTimeOptionRequest) => {
      const client = new EffectRegistrationEvaluationTimeOptionsClient();
      return await client.addEvaluationTimeOption(request.customerId, request.request);
    },
    onSuccess: (_, request) => {
      queryClient.invalidateQueries({ queryKey: ['EVALUATION_TIME_OFFSETS', request.customerId] });
    },
  });
}

interface IAddEvaluationTimeOptionRequest {
  customerId: string;
  request: AddEffectRegistrationEvaluationTimeOptionRequest;
}
